module.exports = __webpack_public_path__ + "img/intenso.ee73fe37.svg";